export const regionFrag = `
    id
    name
    abbreviation
`;
